// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EventsTable_wrapper__3RBd-"};